// Gelo Minimal – Kopfbereich (eingebunden in snippets/gelo-kopf.liquid):
// 1. Suche: Das Horizon-Suchfenster sitzt als Panel direkt unter der Kopf-Unterkante (--gm-suche-top, CSS in
//    assets/gelo-kopfbereich.css). Gemessen beim Öffnen, weil die Hinweisleiste beim Scrollen wegläuft.
// 2. Kauflinie wie im Entwurf: Nach jedem erfolgreichen „In die Tasche“ (Horizon-Ereignis shopify:cart:lines-update,
//    gemeldet von Produktformular, Karten und Tasche) zeichnet sich die Kopf-Unterkante von links nach rechts durch.
// 3. Tasche: Ab 990 px liegt sie mit Schleier über der Seite (CSS); ein Klick auf den Schleier schließt sie, der Fokus
//    bleibt in der Tasche (auch nach den Express-Knöpfen).
//    „Damen“ (Knopf statt Link „#“): Ein Mausklick schließt das schon per Überfahren offene Untermenü nicht; Enter
//    schaltet trotz des Zusatz-Klicks der Instafeed-App genau einmal um.
// 4. Menü-Schublade: Nach dem Schließen (Esc, „Schließen“, Link) bekommt „Menü“ den Fokus zurück (Horizon lässt ihn
//    auf <body> fallen).
// 5. Unter 990 px immer die Schublade („Menü“, Lupe, Tasche), auch ohne Touch – wie die Vorlage unter 1024 px.

const RUHIG = window.matchMedia('(prefers-reduced-motion: reduce)');

function sucheAnsetzen() {
  const kopf = document.getElementById('header-component');
  const unten = kopf ? Math.max(0, Math.round(kopf.getBoundingClientRect().bottom)) : 0;
  document.documentElement.style.setProperty('--gm-suche-top', `${unten}px`);
}

document.addEventListener(
  'click',
  (ereignis) => {
    const ziel = ereignis.target instanceof Element ? ereignis.target : null;
    if (ziel?.closest('search-button, .search-action')) sucheAnsetzen();
  },
  true
);
window.addEventListener('resize', () => {
  if (document.querySelector('#search-modal dialog[open]')) sucheAnsetzen();
});

let zeitKauf = 0;
function kauflinie() {
  const kopf = document.getElementById('header-component');
  if (!kopf || RUHIG.matches) return;
  let linie = kopf.querySelector(':scope > .gm-kauflinie');
  if (!linie) {
    linie = document.createElement('span');
    linie.className = 'gm-kauflinie';
    linie.setAttribute('aria-hidden', 'true');
    kopf.append(linie);
  }
  clearTimeout(zeitKauf);
  kopf.classList.remove('gm-ist-kauf', 'gm-ist-weg');
  void linie.offsetWidth; // Neustart der Linie bei schnellem Doppelkauf
  kopf.classList.add('gm-ist-kauf');
  zeitKauf = window.setTimeout(() => {
    kopf.classList.add('gm-ist-weg');
    zeitKauf = window.setTimeout(() => kopf.classList.remove('gm-ist-kauf', 'gm-ist-weg'), 320);
  }, 520 + 900);
}

document.addEventListener('shopify:cart:lines-update', (ereignis) => {
  const daten = /** @type {any} */ (ereignis);
  if (daten.action && daten.action !== 'add') return;
  const versprechen = daten.promise;
  if (!versprechen?.then) return;
  versprechen
    .then((ergebnis) => {
      if (ergebnis?.detail?.didError || ergebnis?.userErrors?.length) return;
      kauflinie();
    })
    .catch(() => {});
});

// ---------- 3. Tasche: Klick auf den Schleier schließt ----------
// Der Schleier ist #cart-drawer::before; ein Klick darauf trifft das Element selbst, nicht die Schublade darin.
document.addEventListener('click', (ereignis) => {
  const tasche = document.getElementById('cart-drawer');
  if (!tasche || ereignis.target !== tasche || !tasche.hasAttribute('open')) return;
  const schublade = /** @type {any} */ (tasche);
  if (typeof schublade.close === 'function') schublade.close();
});

// ---------- 3a. Tasche: Fokus bleibt in der Tasche ----------
// Ab 990 px öffnet Horizon die Tasche nicht modal (show() mit eigener Fokusfalle, assets/focus.js). Die Falle kennt
// die Express-Knöpfe (Shop Pay, PayPal, Google Pay: Shadow DOM, Rahmen) nicht richtig: Nach dem letzten sprang Tab
// hinter den Schleier auf „Direkt zum Inhalt“, Umschalt+Tab auf „Schließen“ landete in einem unsichtbaren Rahmen.
// Deshalb: hinter den Knöpfen ein Wächter (.gm-fokus-ende in snippets/cart-drawer.liquid), der auf „Schließen“
// weiterleitet; Umschalt+Tab auf „Schließen“ geht auf das letzte sichtbare Ziel der Tasche („Zur Kasse“); landet der
// Fokus sonst bei offener Tasche außerhalb, kommt er zurück.
let tabRueckwaerts = false;
const FOKUSSIERBAR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

/** Offene, nicht modale Tasche (ab 990 px), sonst null. Modal hält der Browser den Fokus selbst. */
function offeneTasche() {
  const panel = document.querySelector('#cart-drawer > dialog[open]');
  if (!panel) return null;
  try {
    if (panel.matches(':modal')) return null;
  } catch {
    // ältere Browser ohne :modal: wie nicht modal behandeln
  }
  return panel;
}

/** Sichtbare Ziele der Tasche in Dokument-Reihenfolge, ohne die Express-Knöpfe (deren Rahmen und geschlossene Shadow
 *  Roots nehmen den Fokus per Skript nicht verlässlich an; rückwärts geht es deshalb von „Schließen“ auf „Zur Kasse“). */
function taschenZiele(panel) {
  return [...panel.querySelectorAll(FOKUSSIERBAR)].filter(
    (el) =>
      !el.matches('.gm-fokus-ende') &&
      el.getBoundingClientRect().width > 0 &&
      el.getBoundingClientRect().height > 0 &&
      getComputedStyle(el).visibility !== 'hidden' &&
      !el.closest('[inert], [hidden], [aria-hidden="true"]')
  );
}

/** Fokus auf „Schließen“ (vorwärts) bzw. das letzte Ziel, das ihn annimmt (rückwärts). */
function fokusInTasche(panel, vorher) {
  if (!tabRueckwaerts) {
    const zu = panel.querySelector('.gm-tasche__zu');
    if (zu instanceof HTMLElement) zu.focus({ preventScroll: true });
    return;
  }
  const ziele = taschenZiele(panel);
  for (let i = ziele.length - 1; i >= 0; i -= 1) {
    const el = ziele[i];
    if (!(el instanceof HTMLElement)) continue;
    el.focus({ preventScroll: true });
    if (document.activeElement !== vorher && panel.contains(document.activeElement)) return;
  }
}

// vor Horizons Falle (die erst beim Öffnen angemeldet wird)
document.addEventListener(
  'keydown',
  (ereignis) => {
    if (ereignis.key !== 'Tab') return;
    tabRueckwaerts = ereignis.shiftKey;
    if (!ereignis.shiftKey) return;
    const panel = offeneTasche();
    const aktiv = document.activeElement;
    if (!panel || !(aktiv instanceof Element) || !(aktiv === panel || aktiv.matches('.gm-tasche__zu'))) return;
    ereignis.preventDefault();
    ereignis.stopImmediatePropagation();
    fokusInTasche(panel, aktiv);
  },
  true
);

document.addEventListener(
  'focusin',
  (ereignis) => {
    const panel = offeneTasche();
    const ziel = ereignis.target;
    if (!panel || !(ziel instanceof Element)) return;
    if (ziel.matches('.gm-fokus-ende')) {
      fokusInTasche(panel, ziel);
      return;
    }
    if (panel.contains(ziel) || ziel.closest('dialog[open]')) return; // andere offene Dialoge (Suche) nicht stören
    fokusInTasche(panel, ziel);
    // Tab aus einem Rahmen heraus setzt den Fokus u. U. nach diesem Ereignis noch einmal: dann kurz danach erneut
    setTimeout(() => {
      if (document.activeElement === ziel) fokusInTasche(panel, ziel);
    }, 0);
  },
  true
);

// ---------- 3b. Knöpfe der Navigation („Damen“, „Mehr“, Pfeile) ----------
// Mit der Maus öffnet schon das Überfahren das Untermenü; ein Klick auf „Damen“ soll es dann nicht wieder schließen.
// Bei Enter löst eine App (Instafeed, cdn.nfcube.com) zusätzlich einen eigenen Klick aus, der das Menü sofort wieder
// zuklappt: diesen zweiten, nicht vom Nutzer stammenden Klick verwerfen. Tastatur und Touch schalten sonst über Horizon.
const NAV_KNOPF = 'header-menu button';
let enterAufKnopf = false;
window.addEventListener(
  'keydown',
  (ereignis) => {
    const ziel = ereignis.target instanceof Element ? ereignis.target : null;
    enterAufKnopf = ereignis.key === 'Enter' && Boolean(ziel?.closest(NAV_KNOPF));
  },
  true
);
window.addEventListener(
  'click',
  (ereignis) => {
    const knopf = ereignis.target instanceof Element ? ereignis.target.closest(NAV_KNOPF) : null;
    if (!knopf) return;
    if (!ereignis.isTrusted && enterAufKnopf) {
      ereignis.stopPropagation();
      ereignis.preventDefault();
      return;
    }
    enterAufKnopf = false;
    const maus = ereignis.detail > 0 && window.matchMedia('(hover: hover)').matches;
    if (maus && knopf.matches('.gm-menue-knopf') && knopf.getAttribute('aria-expanded') === 'true') ereignis.stopPropagation();
  },
  true
);

// ---------- 4. Menü-Schublade: Fokus zurück auf „Menü“ ----------
document.addEventListener(
  'toggle',
  (ereignis) => {
    const details = ereignis.target;
    if (!(details instanceof HTMLDetailsElement) || details.id !== 'Details-menu-drawer-container' || details.open) return;
    const aktiv = document.activeElement;
    if (aktiv && aktiv !== document.body && !details.contains(aktiv)) return; // Fokus ist schon woanders (z. B. Link)
    details.querySelector('summary')?.focus({ preventScroll: true });
  },
  true
);

// ---------- 5. Unter 990 px immer die Schublade ----------
// Horizon wählt die Schublade nur bei Touch oder wenn die Navigation gar nicht mehr passt; zwischen 750 und 989 px
// stünde sonst eine gekürzte Navigation mit „Mehr“. Horizon setzt data-menu-style bei Größenänderungen neu
// (utilities.js setHeaderMenuStyle), deshalb wird das Attribut beobachtet; ab 990 px gilt wieder Horizons Wahl.
const SCHMAL = window.matchMedia('(max-width: 989px)');
function schubladeUnter990() {
  const kopf = document.getElementById('header-component');
  if (kopf && SCHMAL.matches && kopf.dataset.menuStyle === 'menu') kopf.dataset.menuStyle = 'drawer';
}
const kopfKomponente = document.getElementById('header-component');
if (kopfKomponente) {
  new MutationObserver(schubladeUnter990).observe(kopfKomponente, { attributes: true, attributeFilter: ['data-menu-style'] });
  schubladeUnter990();
}
SCHMAL.addEventListener('change', schubladeUnter990);
